import { FormElementTableColumnKind } from '@gearbelt/global';

// Labels for the config fields the form designer exposes as EDITABLE controls.

export const DateConfigLabels = {
  isSubmissionDate: 'Use as form submission date',
} as const;

export const IssueSelectConfigLabels = {
  requirePhotos: 'Require photos',
} as const;

export const UnitReadingConfigLabels = {
  unitId: 'Unit',
  allowLowerReading: 'Allow Lower Reading',
} as const;

export const DropdownConfigLabels = {
  source: 'List Source',
  sourceStatic: 'Manual typed',
  sourceList: 'Link to a List',
  options: 'List items',
  listId: 'Select a list',
} as const;

export const TableConfigLabels = {
  columns: 'Columns',
} as const;

// Display names for the column kinds a table column can be set to.
export const TableColumnConfigLabel: Record<FormElementTableColumnKind, string> = {
  [FormElementTableColumnKind.SingleLineInput]: 'Single line text',
  [FormElementTableColumnKind.Number]: 'Number',
  [FormElementTableColumnKind.Date]: 'Single date',
  [FormElementTableColumnKind.Time]: 'Single time',
  [FormElementTableColumnKind.Dropdown]: 'Dropdown',
};

export const LogicRuleConfigLabels = {
  addLogic: 'Add conditional logic',
  ifValue: 'If value',
  operator: 'Operator',
  operatorIs: 'is',
  operatorIsNot: 'is not',
  matchValues: 'Match values',
  valuesPlaceholder: 'Select value',
  then: 'then',
  showFields: 'Show fields',
  cloneRule: 'Clone rule',
  deleteRule: 'Delete rule',
  revealBoxHint: 'Drag fields here to show them when the condition is met',
  deletedValueMessage: 'This rule uses a value that no longer exists in the list',
  valuesStillLoading: 'List values are still loading. Try saving again in a moment.',
  valuesUnverifiable: "Couldn't check this rule's list values. Edit the rule, or pick a list, then try again.",
} as const;
